import PropTypes from 'prop-types';
import React from 'react';
import Typography from 'fuse-ui/components/Typography';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ( {
    copyright: {
        'float': 'left'
    },
    link: {
        textDecoration: 'none'
    },
    links: {
        display: 'inline-block',
        'float': 'right'
    },
    linkText: {
        color: theme.palette.text.link,
        display: 'inline',
        marginLeft: theme.spacing.unit * 2,
        textDecoration: 'none'
    },
    root: {
        width: 480
    }
} );

const ProofpointCopyright = ( { classes } ) => {
    return (
        <div className={classes.root}>
            <Typography className={classes.copyright} color="textSecondary">© Proofpoint, Inc. 2019 All Rights Reserved. </Typography>
            <div className={classes.links}>
                <a href="https://www.proofpoint.com/us/privacy-policy" className={classes.link} data-automation-id="pfpt-policy-link">
                    <Typography className={classes.linkText}>Privacy</Typography>
                </a>
                <a href="https://registration.proofpoint.com/termsconditions/" className={classes.link} data-automation-id="pfpt-terms-link">
                    <Typography className={classes.linkText}>Terms</Typography>
                </a>
            </div>
        </div>
    );
};

ProofpointCopyright.propTypes = {
    classes: PropTypes.object.isRequired
};

export default withStyles( styles )( ProofpointCopyright );
